import { tableViewNames } from '../../../../agent-production/constants/agentProductionConstants';
import { modules } from '../../../../constants';

export const CROSS_VIEW_SELECTION_MODULES = [
    modules.proficiencyMetrics.transactions,
    modules.proficiencyMetrics.agents,
    modules.proficiencyMetrics.offices,
    modules.proficiencyMetrics.savedAgents,
    modules.proficiencyMetrics.suggestedAgents,
];

export const CROSS_VIEW_SELECTION_TABLES = [
    tableViewNames.overview,
    tableViewNames.overviewCoopAgents,
    tableViewNames.incDecOverview,
    tableViewNames.contactInformation,
    tableViewNames.growthAnalysisLtm,
    tableViewNames.growthAnalysisYtd,
    tableViewNames.growthAnalysisL90,
    tableViewNames.incDecGrowthAnalysisLtm,
    tableViewNames.incDecGrowthAnalysisYtd,
    tableViewNames.listingProficiency,
];

export const getIsCrossViewSelectionEnabled = (module, tableViewName) => {
    return CROSS_VIEW_SELECTION_MODULES.includes(module)
        && CROSS_VIEW_SELECTION_TABLES.includes(tableViewName);
};

export const getIsCrossViewSelectionModule = (module) => {
    return CROSS_VIEW_SELECTION_MODULES.includes(module);
};

export const getSelectedAgentIds = (state) => {
    const moduleState = state[state.selectedModule];
    if (state.selectedModule === modules.proficiencyMetrics.suggestedAgents) {
        const tabId = moduleState?.currentTabId;
        return tabId ? moduleState?.selectedAgentIdsByTab?.[tabId] : undefined;
    }
    return moduleState?.selectedAgentIds;
};
